export enum IPortalLoginTabs {
    "REGISTER" = "register",
    "LOGIN" = "login",
    "CREATE_PASSWORD" = "create_password",
}

export enum IAmRespondingTypes {
    TEXT = "text",
    CALL = "call"
} 